import {createMultiStyleConfigHelpers} from '@chakra-ui/styled-system';

const helpers = createMultiStyleConfigHelpers(['root', 'container']);

/**
 * @typedef {import('@chakra-ui/styled-system').PartsStyleInterpolation<{
 *  keys: ("root" | "container")[]
 * }>} EditorialWrapperStyles
 */
export const editorialWrapperStyles = helpers.defineMultiStyleConfig({
  /**
   * @param {Object} args - Component arguments
   * @param {Contentful.EditorialWrapper} args.component - EditorialWrapper component data
   * @param {boolean} [args.isComplete] - Whether component has all fields
   * @param {boolean} [args.isFetching] - Whether additional data is being fetched
   *
   * @returns {EditorialWrapperStyles} - Component styles
   */
  baseStyle: {
    root: {
      width: '100%',
    },
    container: {
      marginX: 'auto',
      paddingX: {base: '20px', lg: '0'},
    },
  },
  variants: {
    'max-width-1280': {
      container: {
        maxWidth: '1280px',
      },
    },
    'max-width-1060': {
      container: {
        maxWidth: '1060px',
      },
    },
  },
});
